import { render, staticRenderFns } from "./PushNotificationHandler.vue?vue&type=template&id=567949f6&scoped=true"
import script from "./PushNotificationHandler.vue?vue&type=script&lang=js"
export * from "./PushNotificationHandler.vue?vue&type=script&lang=js"
import style0 from "./PushNotificationHandler.vue?vue&type=style&index=0&id=567949f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567949f6",
  null
  
)

export default component.exports